import { Menu, MenuButton, MenuItem } from "@szhsin/react-menu";
import "@szhsin/react-menu/dist/index.css";
import React, { useEffect, useState } from "react";
import DataTable, { TableColumn } from "react-data-table-component";
import { BsThreeDots } from "react-icons/bs";
import { FaEye, FaPen } from "react-icons/fa6";
import { MdCastForEducation, MdDelete } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { CustomButton, Sidebar } from "../../components";
import {
  useDeleteCourses,
  useGetCourse,
} from "../../api/useProducts/useCourses";
import { coursesDataType } from "../../api/types/types";
import moment from "moment";
import toast from "react-hot-toast";
import Loader from "../../components/Loader";
import CustomPagination from "../../components/CustomPagination";
import Swal from "sweetalert2";
import { SiGoogleclassroom } from "react-icons/si";

const Courses: React.FC = () => {
  const [page, setPage] = useState(1);

  const { courseData, courseLoading, courseRefetch } = useGetCourse({
    page,
    limit: 5,
  });
  const { mutate } = useDeleteCourses();
  const navigate = useNavigate();

  const handleDelete = (id: number) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#24B1B3",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        mutate(
          { id },
          {
            onSuccess: (data) => {
              toast.success("successfully delete");
              courseRefetch();
            },
            onError: (error: any) => {
              toast.error(error.response.data.message);
            },
          }
        );
      }
    });
  };
  const columns: TableColumn<coursesDataType>[] = [
    {
      name: "Image",
      cell: (row) => (
        <img
          src={row.image || "/images/Placeholder_view_vector.png"}
          alt="Profile"
          className="h-14 rounded-md w-24 object-cover"
        />
      ),
      center: true,
      //   width: "80px",
    },
    {
      name: "Title",
      selector: (row) => row?.title,
      cell: (row) => (
        <span className="text-center font-semibold">{row?.title}</span>
      ),
      //   sortable: true,
      center: true,
    },
    {
      name: "Date",
      selector: (row) => row.createdAt,
      cell: (row) => (
        <span className="bg-green-100 rounded-full text-green-600 px-3 py-1">
          {row.createdAt
            ? moment(row.createdAt).format("DD MMMM, YYYY")
            : "N/A"}
        </span>
      ),
      center: true,
    },

    {
      name: "Actions",
      cell: (row) => (
        <Menu
          menuButton={
            <MenuButton className="">
              <BsThreeDots size={25} />
            </MenuButton>
          }
          transition
          direction="left"
          align="center"
          menuClassName={"!min-w-fit"}
        >
          <MenuItem
            onClick={() => navigate(`/courses/edit/${row.id}`)}
            className={"flex gap-2"}
          >
            <FaPen size={16} className="text-darkCyan" /> Edit
          </MenuItem>
          <MenuItem
            className={"flex gap-2"}
            onClick={() => navigate(`/courses/detail/${row.id}`)}
          >
            <FaEye size={16} className="text-darkCyan" /> View
          </MenuItem>
          {!row?.isCustom && (
            <MenuItem
              className={"flex gap-2"}
              onClick={() => navigate(`/courses/class/edit/${row.id}`)}
            >
              <SiGoogleclassroom size={16} className="text-darkCyan" /> Classes
            </MenuItem>
          )}
          <MenuItem
            onClick={() => handleDelete(row.id)}
            className={"flex gap-2"}
          >
            <MdDelete size={16} className="text-darkCyan" />
            Delete
          </MenuItem>
        </Menu>
      ),
      //   width: "60px",
      center: true,
    },
  ];

  const customStyles = {
    rows: {
      style: {
        minHeight: "72px",
        background: "rgb(241 245 249)",
      },
    },
    headCells: {
      style: {
        padding: "8px",
        paddingRight: "8px",
        minHeight: "72px",
        background: "#EAEAEA",
        fontWeight: "bold",

        // borderRadius: "12px",
      },
    },
    cells: {
      style: {
        paddingLeft: "8px",
        paddingRight: "8px",
      },
    },
  };
  useEffect(() => {
    courseRefetch();
  }, [page]);
  return (
    <Sidebar>
      <div className="flex-1">
        {courseLoading ? (
          <div className="flex h-[80vh] justify-center items-center">
            <Loader />
          </div>
        ) : (
          <>
            <div className="flex justify-between items-center mb-4 mt-8">
              <p className="text-3xl font-semibold">Courses</p>
              <CustomButton
                btntext="Add New Course"
                handleClick={() => navigate("/courses/add")}
                addclass=" font-semibold"
              />
            </div>
            <div className="">
              {courseLoading ? (
                <Loader />
              ) : courseData?.data && courseData?.data.length > 0 ? (
                <div className="">
                  <div className="min-h-[432px]">
                    <DataTable
                      responsive
                      columns={columns}
                      data={courseData?.data || []}
                      customStyles={customStyles}
                      //   pagination
                      //   paginationPerPage={7}
                      //   paginationRowsPerPageOptions={[5, 10, 15]}
                      className="custom-table"
                    />
                  </div>
                </div>
              ) : (
                <div className="flex flex-col text-[#D9D9D9] items-center">
                  <MdCastForEducation size={60} />
                  <p className="text-lg font-semibold">No Courses right now!</p>
                </div>
              )}
            </div>
          </>
        )}
      </div>
      <CustomPagination
        page={page}
        setPage={setPage}
        totalPages={Number(courseData?.meta?.lastPage)}
      />
    </Sidebar>
  );
};

export default Courses;
